(function($) {

	function new_map( $el ) {

		var $markers = $el.find('.marker');
		var zoom = parseInt($el.attr('data-zoom') ? $el.attr('data-zoom') : 16);

		var args = {
			zoom: zoom,
			center		: new google.maps.LatLng(0, 0),
			mapTypeId	: google.maps.MapTypeId.ROADMAP,
			styles: [
				{
					featureType: 'poi.business',
					stylers: [{visibility: 'off'}]
				},
				{
					featureType: 'transit',
					elementType: 'labels.icon',
					stylers: [{visibility: 'off'}]
				}
			],
			disableDefaultUI: true
		};

		var map = new google.maps.Map($el[0], args);


		map.markers = [];

		$markers.each(function() {
			add_marker($(this), map);
		});

		center_map(map, zoom);

		return map;
	}

	function add_marker($marker, map) {

		var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

		var icon = {
			url: $marker.attr('data-icon'),
			scaledSize: new google.maps.Size(34, 26)
		}

		var marker = new google.maps.Marker({
			position	: latlng,
			map			: map,
			icon: icon
		});

		// if marker contains HTML, add it to an infoWindow
		if ($marker.html()) {
			marker.infowindow = new google.maps.InfoWindow({
				content		: $marker.html()
			});

			google.maps.event.addListener(marker, 'click', function() {
				for (var i=0; i<map.markers.length; i++) {
					map.markers[i].infowindow.close();
				}

				marker.infowindow.open(map, marker);
			});
		}

		map.markers.push(marker);

		if ($marker.attr('data-region')) {
			map_locations.push($marker.attr('data-region'));
		}
	}

	function center_map(map, zoom) {
		var bounds = new google.maps.LatLngBounds();

		$.each(map.markers, function(i, marker) {
			if (marker.visible) {
				var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

				bounds.extend(latlng);
			}
		});

		if (map.markers.length == 1) {
			map.setCenter(bounds.getCenter());
			map.setZoom(zoom);
		} else {
			map.fitBounds(bounds);
		}
	}

	function show_locations(region) {
		for (var i=0; i<map_locations.length; i++) {
			if (map_locations[i] == region) {
				map.markers[i].setVisible(true);
			}
		}
	}

	function hide_locations(region) {
		for (var i=0; i<map_locations.length; i++) {
			if (map_locations[i] == region) {
				map.markers[i].infowindow.close();
				map.markers[i].setVisible(false);
			}
		}
	}

	function header_scrolled(scroll) {
		if(scroll > 0) {
			$('header').addClass('scrolled');
		} else {
			$('header').removeClass('scrolled');
		}
	}

	/*
	 *  document ready
	 *
	 *  This function will render each map when the document is ready (page has loaded)
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	5.0.0
	 *
	 *  @param	n/a
	 *  @return	n/a
	 */
	// global var
	var map = null;
	var map_locations = [];

	$(document).ready(function() {

		$('#slider').slick({
			'dots': false,
			'slide': '.slide',
			'arrows': true,
			'appendArrows': '#slider-arrows',
			'autoplay': true,
			'autoplaySpeed': 4000
		});

		$('#steps-slider').slick({
			'dots': false,
			'arrows': false,
			'autoplay': true,
			'speed': 1000,
			'autoplaySpeed': 3000,
			'variableWidth': true,
			'slidesToShow': 4,
			'responsive': [
				{
					breakpoint: 1200,
					settings: {
						'variableWidth': false,
						'slidesToShow': 1,
						'slidesToScroll': 1
					}
				}
			]
		});

		$('#testimonial-slider').slick({
			'dots': false,
			'slidesToShow': 3,
			'swipeToSlide': true,
			'responsive': [
				{
					breakpoint: 992,
					settings: {
						'slidesToShow': 2,
					}
				},
				{
					breakpoint: 768,
					settings: {
						'arrows': false,
						'slidesToShow': 1,
					}
				}
			]
		});

		$('.menu-close').click(function() {
			$('#site-navigation').toggleClass('toggled');
		});

		header_scrolled($(window).scrollTop());

		$(window).scroll(function (event) {
			var scroll = $(window).scrollTop();
			header_scrolled(scroll);

			$('.service-box').each(function() {
				var elemTop = $(this).offset().top;
				if (elemTop < scroll + 200) {
					if (!$(this).hasClass('scrolled')) {
						$(this).addClass('scrolled');
					}
				} else {
					if ($(this).hasClass('scrolled')) {
						$(this).removeClass('scrolled');
					}
				}
			});
		});

		$('.skip-link').click(function(event) {
			event.preventDefault();
			var skipto = $(this).data('skipto');
			if (skipto) {
				var skipPage = $('html, body');

				skipPage.on('mousedown wheel DOMMouseScroll mousewheel touchmove', function() {
					skipPage.stop();
				});

				skipPage.animate({
					scrollTop: $(skipto).offset().top - 80
				}, 1000, function () {
					skipPage.off('mousedown wheel DOMMouseScroll mousewheel touchmove')
				})
			}
		});

		$('.map').each(function() {
			map = new_map($(this));
		});

		$('.map-filter').click(function() {
			var region = $(this).data('region');

			if (!$(this).hasClass('deselected')) {
				$('.map-filter').each(function() {
					var thisRegion = $(this).data('region');
					if (region != thisRegion) {
						$(this).removeClass('deselected');
						hide_locations(thisRegion);
					} else {
						$(this).addClass('deselected');
						show_locations(thisRegion);
					}
				});
			} else {
				$('.map-filter').each(function() {
					var thisRegion = $(this).data('region');
					$(this).removeClass('deselected');
					show_locations(thisRegion);
				});
			}

			center_map(map);
		});

		$('#map_postcode_search').click(function() {
			var postcode = $('#map_postcode').val();
			showClosestMarker(postcode);
			center_map(map);
		});

		function rad(x) {
			return x*Math.PI/180;
		}

		function showClosestMarker(address) {
			var geocoder = new google.maps.Geocoder();
			geocoder.geocode({'address': address}, function(results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					map.setCenter(results[0].geometry.location);
					var lat = results[0].geometry.location.lat();
					var lng = results[0].geometry.location.lng();
					var R = 6371; // radius of earth in km
					var distances = [];
					var closest = -1;
					for( i=0;i<map.markers.length; i++ ) {
						var mlat = map.markers[i].position.lat();
						var mlng = map.markers[i].position.lng();
						var dLat  = rad(mlat - lat);
						var dLong = rad(mlng - lng);
						var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
							Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);
						var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
						var d = R * c;
						distances[i] = d;
						if ( closest == -1 || d < distances[closest] ) {
							closest = i;
						}
						map.markers[i].setVisible(false);
						map.markers[i].infowindow.close();
					}

					map.markers[closest].setVisible(true);
					map.markers[closest].infowindow.open(map, map.markers[closest]);
				} else {
					alert('Sorry, we could not find your location from your postcode, please check it is correct and try again');
				}
			});
		}

		var cookieConsent = {
			'config': {
				'cookieName': 'cookie_consent',
				'cookieValue': 'accepted',
				'cookieExpiry': 90
			},
			'init': function() {
				if(!cookieConsent.checkCookie(cookieConsent.config.cookieName)) {
					$('#cookie-consent').addClass('show');
					$('#cookie-accept').click(function() {
						cookieConsent.setCookie(cookieConsent.config.cookieName, cookieConsent.config.cookieValue, cookieConsent.config.cookieExpiry);
						$('#cookie-consent').removeClass('show');
					});
				}
			},
			'setCookie': function(cname, cvalue, exdays) {
				var d = new Date();
				d.setTime(d.getTime() + (exdays*24*60*60*1000));
				var expires = "expires="+ d.toUTCString();
				document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
			},
			'checkCookie': function(cname) {
				return document.cookie.indexOf(cname+'=') > -1;
			}
		};

		cookieConsent.init();

		// position: sticky polyfill for checkout page
		Stickyfill.add($('#checkout-summary'))

		// refresh button for checkout centre picker
		$('#centre-picker-postcode-button').click(function(e) {
			e.preventDefault();
			$('#checkout-centre-picker-postcode .error').remove();
			$postcode = $('#billing_postcode').val()
			if ($postcode) {
				$.ajax({
					type: 'POST',
					url: tca_local.ajax_url,
					data: {
						'action':'checkout_nearby_centres',
						'postcode': $postcode
					},
					success: function (response) {
						if(response.success && response.nearbyCentres) {
							$('#checkout-centre-picker-postcode').css('display', 'none');
							$('#checkout-centre-picker').html(response.nearbyCentres);
							$('#service-location_field').removeClass('visible');
							$('#checkout-centre-picker .map').each(function() {
								map = new_map($(this));
							});
							centrePickerButtons();
						}
					}
				});
			} else {
				$(this).after('<div class="error">Please enter your postcode above to find nearby centres</div>');
			}
		})

		function centrePickerButtons() {
			$('#checkout-centre-picker .centre-picker-button').click(function(e) {
				e.preventDefault();
				var target = $(this).attr('data-target');
				$('#checkout-centre-picker .centre-picker-panel-single').css('visibility', 'hidden');
				$('#checkout-centre-picker').find('#centre-picker-panel-' + target).css('visibility', 'visible');
				$('#service-location').val(target);
				$(this).hide().siblings().show();

				$('#checkout-summary .summary-centre').html($('.title', this).html());
				updateAppointmentDates();
			});

			$('#service-location_field').removeClass('visible').slideUp(200);

			$('#checkout-centre-picker .see-all-button').click(function(e) {
				e.preventDefault();
				if ($('#service-location_field').hasClass('visible')) {
					$('#service-location_field').removeClass('visible').slideUp(200);
				} else {
					$('#service-location_field').addClass('visible').slideDown(200);
				}
			});

			$('#checkout-centre-picker .centre-picker-button').first().click();
		}

		// checkout centre picker buttons
		centrePickerButtons()

		var d = new Date();
		var hour = d.getHours();
		var cutoff = 14;

		$('.button-collapse').click(function() {
			var openText = 'Read More';
			var closeText = 'Read Less';

			if($(this).html() !== closeText) {
				$(this).html(closeText);
			} else {
				$(this).html(openText);
			}
		});

		$('#filter-search').on('keyup', function() {
			var value = $(this).val().toLowerCase();
			$('.filter-results .filter-item').filter(function() {
				$(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
			});
		});

		$('#filter-select').on('change', function() {
			var value = $(this).val();
			$('.filter-results .filter-item').filter(function() {
				if (value) {
					$(this).toggle($(this).hasClass(value));
				} else {
					$(this).show();
				}
			});
		});

		$('.set-location').bind('click', function(event) {
			event.preventDefault();

			var location_id = $(this).data('location');

			if (location_id != '') {
				var data = {
					'action': 'locations',
					'location_action': 'set_preferred_location',
					'location_id': location_id
				};

				$.post({
					'url': tca_local.ajax_url,
					'data': data,
					'success': function(response) {
						var response = $.parseJSON(response);
						if(response.success) {
							$('.preferred_location').each(function() {
								$(this).removeClass('preferred_location');
								$('.set-location button', this).removeClass('reverse colour-border').html('Set as Preferred Location');
							});

							$('#location-'+location_id).addClass('preferred_location');
							$('.set-location[data-location="'+location_id+'"] button').addClass('reverse colour-border').html('Preferred Location');
						}
					}
				});
			}

		});

		var excluded_dates = [];

		var datepicker_options = {
			'altField': '#appointment-date-value',
			'altFormat': 'dd-mm-yy',
			'dayNamesMin': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
			'firstDay': 0,
			'defaultDate': (hour > cutoff) ? '+2' : '+1',
			'minDate': (hour > cutoff) ? '+2' : '+1',
			'maxDate': '+6m',
			'beforeShowDay': function(date) {
				return datePickerShowDay(date);
			},
			'onSelect': function() {
				updateAppointmentTimes();
				updateSelectedAppointment();
			}
		};

		if ($('.appointment-date').length) {
			$('.appointment-date').datepicker(datepicker_options);
		}

		function datePickerShowDay(date) {
			if (excluded_dates.indexOf($.datepicker.formatDate('yy-mm-dd', date)) !== -1) {
				return [false];
			} else if (date.getDay() != 0) {
				return [true];
			} else {
				return [false];
			}
		}

		updateAppointmentDates();

		$('#service-location').on('change', function() {
			var location = $('option:selected', this).text().split(',')[0];
			$('#checkout-summary .summary-centre').html(location);
			updateAppointmentDates();
		});

		$('#service-appointment-time_field input').on('change', function() {
			updateSelectedAppointment();
		});

		function updateSelectedAppointment() {
			var selected_string = 'Please select a date';

			if ($('#service-appointment-time_field').length) {
				selected_string += ' and time';
			}

			if ($('#appointment-date-value').val()) {
				selected_string = $('#appointment-date-value').val();
			}

			if ($('#service-appointment-time_field input:checked').val()) {
				selected_string += ' at '+$('#service-appointment-time_field input:checked').val();
			}

			$('#service-appointment-selected').html(selected_string);
		}

		function updateAppointmentDates() {
			if ($('#service-appointment').is(':visible') && $('.appointment-date').length) {
				var data = {};
				data.action = 'locations';
				data.location_action = 'get_service_excluded_dates';
				data.location = $('#service-location').val();
				data.date = $('#appointment-date-value').val();

				$.post(tca_local.ajax_url, data, function(response) {
					var response = $.parseJSON(response);

					if (response.success) {
						excluded_dates = response.data;
						$('.appointment-date').datepicker('destroy');
						$('.appointment-date').datepicker(datepicker_options);
						updateAppointmentTimes();
						updateSelectedAppointment();
					}
				});
			}
		}

		function updateAppointmentTimes() {
			var data = {};
			data.action = 'locations';
			data.location_action = 'get_service_timeslots';
			data.location = $('#service-location').val();
			data.type_id = 1;
			data.date = $('#appointment-date-value').val();

			$.post(tca_local.ajax_url, data, function(response) {
				var response = $.parseJSON(response);

				if (response.success) {
					var options_container = $('#service-appointment-time_field');
					options_container.html('');
					$.each(response.data, function(i, item) {
						var disabled = !item.available ? ' disabled' : '';
						options_container.append('<div class="custom-control custom-radio"><input type="radio" class="custom-control-input" value="'+item.id+'" name="service-appointment-time" id="service-appointment-time_'+item.id+'"'+disabled+' /><label class="custom-control-label" for="service-appointment-time_'+item.id+'" class="radio">'+item.name+'&nbsp;&nbsp;'+(item.available ? 'available' : 'booked')+'</label></div>');
					});

					updateSelectedAppointment();
					$('#service-appointment-time_field input').on('change', function() {
						updateSelectedAppointment();
					});
				}
			});
		}

		$('.lookup-reg').submit(function(event) {
			event.preventDefault();

			var vehicle_reg_input = $(this).find('.vehicle-reg-input');
			var form_error = $(this).find('.form-error');
			var lookup_type = vehicle_reg_input.data('lookup-type');
			var vehicle_reg = vehicle_reg_input.val();
			var postcode = $(this).find('.postcode-input').val();
			var manufacturer = $(this).find('.manufacturer-input').val();
			var servicing_level = $(this).find('.servicing-level-input').val();

			var services = ['battery', 'brakes', 'exhaust'];

			var data = {};
			data.action = 'tca_vehicle_lookup';
			data.operation = 'get_vehicle_data';
			data.lookup_type = lookup_type;
			data.vehicle_reg = vehicle_reg;
			data.postcode = postcode;

			$.post(tca_local.ajax_url, data, function(response) {
				var response = $.parseJSON(response);

				if (response.success) {
					if (services.indexOf(lookup_type) === -1) {
						var modal_type = lookup_type;
					} else {
						var modal_type = 'service';
					}
					var modal = $('#'+modal_type+'LookupModal');
					var modal_vehicle_name = modal.find('.vehicle_lookup_name');
					var modal_response_message = modal.find('.response-message');
					var modal_form_fields = modal.find('.modal-form-fields');
					modal_form_fields.html('');
					modal_vehicle_name.text(response.vehicle_name);
					if (lookup_type === 'tyre') {
						modal_form_fields.append('<input type="hidden" name="postcode" value="'+postcode+'" />');
						if (typeof manufacturer !== 'undefined') {
							modal_form_fields.append('<input type="hidden" name="manufacturer" value="'+manufacturer+'" />');
							modal_form_fields.append('<input type="hidden" name="orderby" value="manufacturer" />');
						}
						for (var i = 0, len = response.tyre_details.length; i < len; i++) {
							modal_form_fields.append('<div class="radio"><label><input type="radio" name="tyre-option" class="modal-form-option" data-width="'+response.tyre_details[i].Front.Tyre.SectionWidth+'" data-profile="'+response.tyre_details[i].Front.Tyre.AspectRatio+'" data-rim="'+response.tyre_details[i].Front.Tyre.RimDiameter+'" data-speed="'+response.tyre_details[i].Front.Tyre.SpeedIndex+'" /><span>'+response.tyre_details[i].Front.Tyre.Size+' (front and rear)</span></label></div>');
						}
						if (response.tyre_details.length > 1) {
							modal_response_message.text('Your car came with optional wheel sizes, please select your tyre size below before clicking "Continue":');
						} else {
							modal_response_message.text('Your car has the following wheel size:');
							$('.modal-form-option:first').attr('checked', true);
						}
					} else if (modal_type === 'servicing') {
						if (servicing_level != '') {
							modal_form_fields.append('<input type="hidden" name="servicing_level" value="'+servicing_level+'" />');
						}
					} else if (modal_type === 'service') {
						$('#serviceLookupModal #service_type').val(lookup_type);
					}

					modal.modal('show');
				} else {
					form_error.text('Sorry, we cannot find your car.');
				}
			});
		});

		$('#tyreLookupModal .modal-form').on('submit', function(event) {
			var selected = $('.modal-form-option:checked', this);
			$('#vehicle_lookup_filter_width').val(selected.data('width'));
			$('#vehicle_lookup_filter_profile').val(selected.data('profile'));
			$('#vehicle_lookup_filter_rim').val(selected.data('rim'));
			$('#vehicle_lookup_speed_rating').val(selected.data('speed'));
		});

		$('[data-toggle="popover"]').popover()

		$('.popover-dismiss').popover({
			trigger: 'focus'
		})

		$('.product-options td:not(.variation-quantity, .info)').click(function() {
			$(this).parent().find('.variation-option input[type=radio]').prop('checked', true);
			$(this).parent().find('.variation-quantity input[type=number]').val(function(i, prev) {
				return ++prev;
			});
			if ($(this).parent().hasClass('less-than-recommended')) {
				$(this).parent().addClass('less-than-recommended-active');
				$(this).parent().find('.less-than-recommended').addClass('less-than-recommended-active');
				$(this).closest('.add_multiple_box').find('.has-not-recommended').addClass('is-active');
			}
		});

		$('.add_multiple').submit(function(event) {
			if ($('input.qty', this).length) {
				var has_qty = false;
				$('input.qty', this).each(function() {
					if ($(this).val() > 0) {
						has_qty = true;
					}
				});

				if (!has_qty) {
					event.preventDefault();
					alert('Please select a quantity');
				}
			}

			if ($('input.variation_option', this).length) {
				if (!$('input.variation_option:checked', this).length) {
					event.preventDefault();
					alert('Please select an option');
				}
			}
		});

		function checkBookingType() {
			var data = {};
			data.action = 'bookings';
			data.booking_action = 'check_booking_type';

			$.post(tca_local.ajax_url, data, function(response) {
				var response = $.parseJSON(response);

				if (response.success) {
					if (response.data.is_bookable) {
						$('#service-appointment').show();
						if (response.data.type_id == 1) {
							$('#service-appointment-title-time').hide();
							$('#service-appointment-time_field').hide();
						} else {
							$('#service-appointment-title-time').show();
							$('#service-appointment-time_field').show();
						}
						updateAppointmentDates();
					} else {
						$('#appointment-date-value').val('');
						$('#service-appointment').hide();
					}
				}
			});
		}

		$('body').on('updated_cart_totals', function() {
			checkBookingType();
		});

		$('#service-boxes-expand').click(function() {
			$(this).closest('.service-buttons').toggleClass('expanded')
		})

	});
})(jQuery);
